// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as MenuRouteImport } from './routes/menu'
import { Route as LocationsRouteImport } from './routes/locations'
import { Route as FranchiseRouteImport } from './routes/franchise'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'

const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const MenuRoute = MenuRouteImport.update({
            id: '/menu',path: '/menu',getParentRoute: () => rootRouteImport
          })
const LocationsRoute = LocationsRouteImport.update({
            id: '/locations',path: '/locations',getParentRoute: () => rootRouteImport
          })
const FranchiseRoute = FranchiseRouteImport.update({
            id: '/franchise',path: '/franchise',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AuthRoute: AuthRoute,FranchiseRoute: FranchiseRoute,LocationsRoute: LocationsRoute,MenuRoute: MenuRoute,ShopRoute: ShopRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)